import { changeSkin } from '@/utils/common.js';

export default {
  components: {
  },
  data() {
    return {
      list: []
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    changeSkin,
    download () {}
  }
};
